import * as React from 'react';

const DifferentProblemIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} aria-label="Different problem icon">
    <path
      data-name="Path 97"
      d="M13.008 13.824l.048 1.584h-1.92v-1.584a1.906 1.906 0 011.488-1.872 2.38 2.38 0 00-.048-4.656 2.429 2.429 0 00-2.88 2.352h-1.92a4.313 4.313 0 115.232 4.176zM12 16.32a1.44 1.44 0 101.44 1.44A1.414 1.414 0 0012 16.32zM24 12A12 12 0 1112 0a12 12 0 0112 12zm-1.92 0A10.08 10.08 0 1012 22.08 10.079 10.079 0 0022.08 12z"
      fill="#0a1514"
    />
  </svg>
);

export default DifferentProblemIcon;
